/** Dominant direction must exceed the other by more than this factor for large · small. */
export var COMMUNICATION_CHART_SKEWED_ARROW_RATIO = 2;
var directedCounts = function (stats) {
    var _a, _b;
    return ({
        sentCount: (_a = stats.sentCount) !== null && _a !== void 0 ? _a : 0,
        receivedCount: (_b = stats.receivedCount) !== null && _b !== void 0 ? _b : 0
    });
};
export var getCommunicationChartLinkArrowSizes = function (stats) {
    var _a = directedCounts(stats), sourceToTarget = _a.sentCount, targetToSource = _a.receivedCount;
    var total = sourceToTarget + targetToSource;
    if (total === 0) {
        return { targetArrowSize: 'none', sourceArrowSize: 'none' };
    }
    if (sourceToTarget === 0 || targetToSource === 0) {
        return {
            targetArrowSize: sourceToTarget > 0 ? 'large' : 'none',
            sourceArrowSize: targetToSource > 0 ? 'large' : 'none'
        };
    }
    var max = Math.max(sourceToTarget, targetToSource);
    var min = Math.min(sourceToTarget, targetToSource);
    if (max / min > COMMUNICATION_CHART_SKEWED_ARROW_RATIO) {
        return sourceToTarget > targetToSource
            ? { targetArrowSize: 'large', sourceArrowSize: 'small' }
            : { targetArrowSize: 'small', sourceArrowSize: 'large' };
    }
    return { targetArrowSize: 'medium', sourceArrowSize: 'medium' };
};
